import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './hooks/useAuth';
import { Layout } from './components';
import {
  LoginPage,
  SignupPage,
  DashboardPage,
  InvestigationsPage,
  NewInvestigationPage,
  InvestigationDetailPage,
  SourcesPage,
  NotFoundPage,
} from './pages';

function App() {
  const auth = useAuth();

  // Protected route component
  const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
    if (auth.isLoading) {
      return (
        <div className="min-h-screen bg-gray-950 flex items-center justify-center">
          <div className="text-white">Carregando...</div>
        </div>
      );
    }

    if (!auth.isAuthenticated) {
      return <Navigate to="/login" replace />;
    }

    return children;
  };

  return (
    <Router>
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<LoginPage onLogin={auth.login} isLoading={auth.isLoading} error={auth.error ?? undefined} />} />
        <Route path="/signup" element={<SignupPage onSignup={auth.signup} isLoading={auth.isLoading} error={auth.error ?? undefined} />} />

        {/* Protected routes */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Layout isAuthenticated={auth.isAuthenticated} onLogout={auth.logout}>
                <DashboardPage />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/investigacoes"
          element={
            <ProtectedRoute>
              <Layout isAuthenticated={auth.isAuthenticated} onLogout={auth.logout}>
                <InvestigationsPage />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/investigacoes/nova"
          element={
            <ProtectedRoute>
              <Layout isAuthenticated={auth.isAuthenticated} onLogout={auth.logout}>
                <NewInvestigationPage />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/fontes"
          element={
            <ProtectedRoute>
              <Layout isAuthenticated={auth.isAuthenticated} onLogout={auth.logout}>
                <SourcesPage />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/investigacoes/:id"
          element={
            <ProtectedRoute>
              <Layout isAuthenticated={auth.isAuthenticated} onLogout={auth.logout}>
                <InvestigationDetailPage />
              </Layout>
            </ProtectedRoute>
          }
        ></Route>

        {/* Redirect to dashboard on root */}
        <Route path="/" element={<Navigate to={auth.isAuthenticated ? '/dashboard' : '/login'} replace />} />

        {/* 404 */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Router>
  );
}

export default App;
